/**
 * @copyright Copyright (c) Agence ink
 */

// This script allows a teacher to scan students' qr code in-app


export const scan = () => {
  
  let qr = document.querySelector('.btn-start-scan');
  if (qr) {
    const qrcode = window.qrcode;
    
    const video = document.createElement("video");
    const canvasElement = document.querySelector(".qr-canvas");
    const canvas = canvasElement.getContext("2d");

    const qrResult = document.querySelector(".qr-error");
    const btnScanQR = document.querySelector(".btn-start-scan");

    let scanning = false;

    // Called if a code as been decoded
    qrcode.callback = (res) => {
      if (res) {
        if (res.includes(window.location.hostname)) {
          window.location = res;
        } else {
          let errorMsg = qrResult.innerHTML; 
          if (res == "https://www.youtube.com/watch?v=dQw4w9WgXcQ") {
            qrResult.textContent = "Lol nice try xD";
          }
          qrResult.style.display = "flex";
          setTimeout(() => { 
            qrResult.style.display = "none";
            qrResult.innerHTML = errorMsg;
            scan();
          }, 2000);
        }
      }
    };

    // Start the qr scanner
    let startScan = () => {
      navigator.mediaDevices
      .getUserMedia({ video: { facingMode: "environment" } })
      .then(function(stream) {
        scanning = true;
        btnScanQR.style.display = "none";
        canvasElement.style.display = "block";
        video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
        video.srcObject = stream;
        video.play();
        tick();
        scan();
        console.log(video)
      });
    };
    
    window.addEventListener('load', startScan);
    btnScanQR.addEventListener('click', startScan);

    function tick() {
      canvasElement.height = video.videoHeight;
      canvasElement.width = video.videoWidth;
      canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
    
      scanning && requestAnimationFrame(tick);
    }

    function scan() {
      try {
        qrcode.decode();
      } catch (e) {
        setTimeout(scan, 300);
      }
    }
  }
}
